import useAsyncData from "../../../../hooks/use-async-data";
import contractsService from "../../contracts.service";
import ContractsMileageTemplate from "./contracts-mileage-template";

const useContractsMileageTemplate = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<ContractsMileageTemplate | null>(null);

  const load = async (signal: AbortSignal): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const mileageList =
        await contractsService.getMileageContractTemplate(signal);

      setData(mileageList);
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useContractsMileageTemplate;
